<template lang="pug">
  .page-header-container(:style="headerStyle")
    .header-nav-area
      img.back-icon(:src="backIcon" @click="goBack")
      .page-title-area
        PageTitle(
          :titleIcon="pageHeaderConfig.titleIcon"
          :titleDesc="pageHeaderConfig.titleDesc"
          :hideTitle="headerActive && isMixPage"
          :pageKey="pageHeaderConfig.pageKey"
          :styleVersion="styleVersion"
        )
          template(
            slot='left'
            v-if="pageHeaderConfig.pageKey === pageKeyEnum.bounty && headerActive && !isMixPage"
          )
            MyPointsEntry(:points="points" @pointsClick="goBountyRecord")

    .header-extra-area(
      v-if="pageHeaderConfig.pageKey === pageKeyEnum.bounty && isMixPage"
      :class="{ 'hide': !headerActive }"
    )
      MyPointsEntry(:points="points" @pointsClick="goBountyRecord")

    .header-tab-area(
      v-if="isMixPage"
      :class="{ 'ceiling': headerActive }"
    )
      PageTab(
        :defaultActiveTab="pageHeaderConfig.pageKey"
        :isCeiling="headerActive"
        @changeTab="handleChangeTab"
      )
</template>

<script>
import { env, Native } from '@hb/NBridge/lib/h5';
import eventBus from '@/const/eventBus';
import { BLACK_LEFT_ICON } from '@/const';
import config from '@/const/config';
import { jumpUrl } from '@/utils/tools';
import { getPageConfig } from '../common/helper';
import SPM from '../common/spm';
import PageTab from './page-tab';
import MyPointsEntry from './my-points-entry';
import PageTitle from './page-title';
import { WELFARE_CENTER_PAGE_KEY } from '../consts';

export default {
  name: 'PageHeader',
  components: {
    PageTab,
    MyPointsEntry,
    PageTitle,
  },
  props: {
    // 默认页面tab
    pageTab: {
      type: String,
      default: WELFARE_CENTER_PAGE_KEY.bounty,
    },
    // 是否是聚合页面
    isMixPage: {
      type: Boolean,
      default: false,
    },
    // 页面样式版本
    styleVersion: {
      type: String,
      default: '',
    },
    // 是否为顺风车心智版本
    isHitchCarFare: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 滚动距离
      scrollTop: 0,
      // 返回图标
      backIcon: BLACK_LEFT_ICON,
      // 页面配置
      pageHeaderConfig: {},
      // 页面key枚举
      pageKeyEnum: WELFARE_CENTER_PAGE_KEY,
      // 是否是App端
      isApp: env.isEasyBikeApp,
      // 奖励金数量
      points: 0,
    };
  },
  inject: ['titleBarHeight'],
  computed: {
    headerActive() {
      return this.scrollTop > 25;
    },
    headerStyle() {
      const { headerColor } = this.pageHeaderConfig;
      const titleBarHeight = this.titleBarHeight();
      return {
        backgroundColor: this.headerActive ? headerColor : 'transparent',
        height: `${titleBarHeight / 100}rem`,
      };
    },
    isShowTopPoints() {
      return (
        !this.isMixPage
        && this.pageHeaderConfig.pageKey === this.pageKeyEnum.bounty
        && this.headerActive
      );
    },
  },
  created() {
    this.pageHeaderConfig = getPageConfig(this.pageTab, this.isMixPage, this.isHitchCarFare);
  },
  mounted() {
    window.addEventListener('scroll', this.scrollHandler, true);
    // 监听奖励金数量变化
    eventBus.$on('pointsChange', (data) => {
      const { points } = data || {};
      this.points = points;
    });
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollHandler, true);
  },
  methods: {
    // 监听滚动
    scrollHandler(e) {
      const { pageKey } = this.pageHeaderConfig;

      if (
        pageKey === WELFARE_CENTER_PAGE_KEY.coupon
        && e.target
        && e.target.id === 'welfare-module-scroll-container'
      ) {
        this.scrollTop = e.target.scrollTop;
      }

      if (pageKey === WELFARE_CENTER_PAGE_KEY.bounty) {
        this.scrollTop = document.documentElement.scrollTop
          || window.pageYOffset
          || document.body.scrollTop;
      }
    },
    // 处理tab切换
    handleChangeTab(key) {
      this.pageHeaderConfig = getPageConfig(key, this.isMixPage, this.isHitchCarFare);
      this.scrollTop = 0;
      this.$emit('changeTab', key, 'click');
    },
    // 跳转奖励金记录页面
    goBountyRecord() {
      SPM.clickButton({
        buttonName: 'my_bonus_new',
        businessInfo: {},
      });
      jumpUrl(
        `https://m.hellobike.com/AppPlatformH5/${
          config.env !== 'pro' ? `${config.env}/` : ''
        }latest/index.html#/bounty/exchange?adsource=1`,
      );
    },
    // 返回
    goBack() {
      if (env.isEasyBikeApp) {
        Native.goBack();
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.page-header-container {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 50 !important;
  padding: 0.44rem 0.12rem 0;
  width: 100vw;
  height: 0.88rem;
  transition: background 0.3s ease;
  background-color: transparent;
  box-sizing: border-box;

  .header-nav-area {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 0.42rem;

    .back-icon {
      position: relative;
      z-index: 1;
      margin-right: 0.06rem;
      width: 0.24rem;
      height: 0.24rem;
      vertical-align: bottom;
    }

    .page-title-area {
      flex: 1;
    }
  }

  .header-extra-area {
    position: absolute;
    margin-top: 0.09rem;
    transition: all 0.3s ease;

    &.hide {
      opacity: 0;
    }

    .title {
      font-weight: 500;
      font-size: 0.14rem;
      color: #404040;
    }
  }

  .header-tab-area {
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    margin-top: 0.04rem;

    &.ceiling {
      transform: translateY(-0.42rem);
    }
  }
}
</style>
